import {Flex, ModalContext, Text, Box} from 'exsportia-components'
import {FC, useContext, useMemo, useState, useCallback} from 'react'

import {theme} from '../../theme/theme'
import {Button} from '../../ui/components/button/button'
import {useLocale} from '../../utils/i18n'
import {QRCode} from '../qr-code/qr-code'

export type QRModalProps = {
  venueId?: string
  value: string
  bookingCode?: string
}

export const QRModal: FC<QRModalProps> = ({value, bookingCode}) => {
  const {l} = useLocale()
  const {closeModal} = useContext(ModalContext)
  const Theme = theme
  const [isFullScreen, setIsFullScreen] = useState(false)

  const toggleFullScreen = useCallback(() => {
    setIsFullScreen((prev) => !prev)
  }, [])

  const qrCodeMarkup = useMemo(() => {
    return (
      <Box
        p={Theme.spaces.multiplier2x}
        border={Theme.borders['default-border']}
        borderRadius={Theme.radii.multiplier2x}
        backgroundColor={Theme.colors.white}
        display='flex'
        flexDirection='column'
        alignItems='center'
        gap={Theme.spaces.multiplier2x}
      >
        <QRCode
          value={value}
          downloadable={false}
          onClick={toggleFullScreen}
          cursor='pointer'
          settings={{size: 300}}
        />
        {bookingCode && (
          <Text
            settings={{
              fontSize: Theme.fontSizes.body,
              color: Theme.colors['text-primary'],
            }}
          >
            {bookingCode}
          </Text>
        )}
      </Box>
    )
  }, [value, bookingCode, Theme, toggleFullScreen])

  if (isFullScreen) {
    return (
      <Flex
        position='fixed'
        top={0}
        left={0}
        width='100vw'
        height='100vh'
        backgroundColor={Theme.colors.white}
        zIndex={9999}
        flexDirection='column'
        alignItems='center'
        justifyContent='center'
        onClick={toggleFullScreen}
        p='24px'
      >
        <QRCode
          value={value}
          downloadable={true}
          settings={{size: 350, p: 20}}
          onClick={(e: any) => e.stopPropagation()}
        />
        {bookingCode && (
          <Box mt='24px'>
            <Text
              settings={{
                fontSize: '24px',
                fontWeight: 700,
                color: Theme.colors['text-primary'],
              }}
            >
              {bookingCode}
            </Text>
          </Box>
        )}
        <Box mt='40px'>
          <Button
            type='flat'
            onClick={(e) => {
              e.stopPropagation()
              toggleFullScreen()
            }}
          >
            {l('close')}
          </Button>
        </Box>
      </Flex>
    )
  }

  return (
    <Flex
      alignItems='center'
      flexDirection='column'
      pb='16px'
      gap='24px'
      px='24px'
    >
      {qrCodeMarkup}

      <Flex
        flexDirection='column'
        alignItems='center'
        gap='8px'
      >
        <Text
          settings={{
            fontSize: Theme.fontSizes.h2,
            fontWeight: 700,
            color: Theme.colors['text-primary'],
          }}
        >
          {l('scanToCheckIn')}
        </Text>
        <Text
          settings={{
            fontSize: '14px',
            color: Theme.colors['text-secondary'],
            textAlign: 'center',
          }}
        >
          {l('qrDescription')}
        </Text>
      </Flex>

      <Button
        type='flat'
        onClick={closeModal}
      >
        {l('close')}
      </Button>
    </Flex>
  )
}
